// Public USD offers, verified against Plan and PayPal on October 19, 2026.
export const basicMonthlyAmount=89;
export const advancedMonthlyAmount=109;
export const basicYearlyAmount=899;
export const advancedYearlyAmount=1099;
export const basicWeekAmount=34;
export const advancedWeekAmount=49;
